// eslint-disable-next-line import/prefer-default-export
export const currentYear = () => new Date().getFullYear().toString()



// WEBPACK FOOTER //
// ./src/components/helpers/date.js